// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.mjs";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.mjs";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as Environments$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/Environments.mjs";
import * as NetworkUtils$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/NetworkUtils.mjs";
import * as NetworkHelper$PorterinFeature from "../../../../shared/core/helpers/NetworkHelper.mjs";
import * as FareEstimateResultStoreEn$PorterinFeature from "../../../../shared/core/constants/FareEstimateResultStoreEn.mjs";
import * as FareEstimateResultDummyJson$PorterinFeature from "../store/FareEstimateResultDummyJson.mjs";
import * as FareEstimateResultRepoConfig$PorterinFeature from "./FareEstimateResultRepoConfig.mjs";
import * as FareEstimateResultRepoHelper$PorterinFeature from "../helpers/FareEstimateResultRepoHelper.mjs";

function fetchFareEstimateResult(query_params) {
  var requestUrl = FareEstimateResultRepoHelper$PorterinFeature.getFareEstimateResultUrl(query_params);
  if (Config$PorterinUtils.env === Environments$PorterinUtils.development) {
    return Js_promise.then_((function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(FareEstimateResultRepoConfig$PorterinFeature.OmsResponseConverter.execute, result);
                            });
                }), new Promise((function (resolve, param) {
                      resolve({
                            TAG: /* Success */0,
                            _0: FareEstimateResultDummyJson$PorterinFeature.FareEstimateResultRepo.homeOmsDummyResponse
                          });
                    })));
  } else {
    return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                      return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                  return Curry._1(FareEstimateResultRepoConfig$PorterinFeature.OmsResponseConverter.execute, result);
                                });
                    }), Network$Catalyst.getRequestV2(requestUrl, undefined, undefined, undefined)), requestUrl);
  }
}

function encodeFareEstimateCallBackRequestInfo(mobile, request_id) {
  var payload = {};
  payload["request_id"] = request_id;
  payload["cust_mobile"] = mobile;
  return payload;
}

function submitCallBackRequest(mobile, request_id) {
  var payloadString = JSON.stringify(encodeFareEstimateCallBackRequestInfo(mobile, request_id));
  var requestUrl = Config$PorterinUtils.oms_url + "/callback_request_infos/change_request_status";
  return NetworkUtils$PorterinUtils.catchPromiseError(Js_promise.then_((function (result) {
                    return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                                return Curry._1(FareEstimateResultRepoConfig$PorterinFeature.FareEstimateResultCallBackRequestApiResponseConverter.execute, result);
                              });
                  }), Network$Catalyst.postRequest(requestUrl, payloadString, undefined, undefined)), requestUrl);
}

function pnmRedirectUrl(request_id) {
  JsBindings$PorterinUtils.redirect(Config$PorterinUtils.oms_url + "/packers-and-movers?request_id=" + request_id);
}

function getCustomerExistFlag(mobile) {
  var headers = {
    brand: FareEstimateResultStoreEn$PorterinFeature.brand_label,
    source: FareEstimateResultStoreEn$PorterinFeature.source_website_label
  };
  var headersWithLocale = NetworkHelper$PorterinFeature.assignLocaleHeaders(headers);
  var payload = {};
  payload["mobile"] = mobile;
  var requestUrl = Config$PorterinUtils.wag_url + ("/customer/exists/" + mobile + "");
  if (Config$PorterinUtils.env === Environments$PorterinUtils.development) {
    return Js_promise.then_((function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(FareEstimateResultRepoConfig$PorterinFeature.CustomerCheckExistApiResponseConverter.execute, result);
                            });
                }), new Promise((function (resolve, param) {
                      resolve({
                            TAG: /* Success */0,
                            _0: FareEstimateResultDummyJson$PorterinFeature.dummyCheckCustomerExist
                          });
                    })));
  } else {
    return Js_promise.then_((function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(FareEstimateResultRepoConfig$PorterinFeature.CustomerCheckExistApiResponseConverter.execute, result);
                            });
                }), NetworkV2$Catalyst.get(requestUrl, Caml_option.some(headersWithLocale), undefined, undefined, undefined, undefined));
  }
}

export {
  fetchFareEstimateResult ,
  encodeFareEstimateCallBackRequestInfo ,
  submitCallBackRequest ,
  pnmRedirectUrl ,
  getCustomerExistFlag ,
}
/* Network-Catalyst Not a pure module */
